import { DataBean } from "../DataBean";

export class FinishedContracts extends DataBean {



    public async getFinishedEmployeeContracts(yearFrom:any,yearUpto:any,idEmployee:any,page:any,recordsPerPage:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getFinishedEmployeeContracts_Number_Number_Number_Number_Number", [yearFrom,yearUpto,idEmployee,page,recordsPerPage]);
    }
    
}